// hooks/useScrollMenuHandler.ts
import { useEffect, useRef, useState } from 'react';
import menuStore from '../store/MenuStore';

export const useScrollMenuHandler = () => {
  const SCROLL_THRESHOLD = 5;
  const SCROLL_COOLDOWN_MS = 1000;
  const [lastScrollTime, setLastScrollTime] = useState<number>(0);
  const prevScrollYRef = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const now = Date.now();
      let isSnapDown = false;
      let isSnapUp = false;
      let scrollDown = false;
      let scrollUp = false;

      const deltaY = window.scrollY - prevScrollYRef.current;

      if (now - lastScrollTime >= SCROLL_COOLDOWN_MS) {
        const absDeltaY = Math.abs(deltaY);
        //console.log('absDeltaY: ', absDeltaY);
        if (absDeltaY >= SCROLL_THRESHOLD) {
          isSnapDown = deltaY > 0;
          isSnapUp = deltaY < 0;
          setLastScrollTime(now);
        } else if (absDeltaY >= SCROLL_THRESHOLD) {
          scrollDown = deltaY > 0;
          scrollUp = deltaY < 0;
        }
      }

      prevScrollYRef.current = window.scrollY;

      if (scrollDown || isSnapDown) {
        menuStore.hide();
      } else if (scrollUp || isSnapUp || window.scrollY === 0) {
        menuStore.show();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [lastScrollTime]);
};
